import { Injectable } from '@angular/core';
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { AuthenticationService } from '../service';

@Injectable({ providedIn: 'root' })
export class NoAuthGuards implements CanActivate {
  constructor(
    private _router: Router,
    private _authenticationService: AuthenticationService
  ) {}

  // canActivate
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const currentUser = this._authenticationService.currentUserValue;

    if (!currentUser) {
      return true;
    }
    const subdomain = localStorage.getItem('currentUserSubdomainMybenefits')
      ? localStorage.getItem('currentUserSubdomainMybenefits')
      : 'default';
    this._router.navigate(['/' + subdomain + '/']);
    return false;
  }
}
